import { VOTE_AREA_SUCCESS, VOTE_AREA_FAILURE } from '../actions/types';

const initialState = {
  submitted: false,
  error: null,
};

export default function voteAreaReducer(state = initialState, action = {}) {
  switch (action.type) {
    case VOTE_AREA_SUCCESS:
      return {
        ...state,
        submitted: true,
      };
    case VOTE_AREA_FAILURE:
      return {
        ...state,
        submitted: false,
        error: {
          status: action.status,
          message: action.message,
          type: action.payload.type,
        },
      };
    default:
      return state;
  }
}
